import React, { createContext, useContext, useMemo, useState } from 'react';

export interface NavigationConfirmationContextType {
  navigationBlocked: boolean;
  setNavigationBlocked: React.Dispatch<React.SetStateAction<boolean>>;
}

export const NavigationConfirmationContext =
  createContext<NavigationConfirmationContextType | null>(null);

interface Props {
  children?: React.ReactNode;
}

export const NavigationConfirmationContextProvider: React.FC<Props> = ({
  children,
}) => {
  const [navigationBlocked, setNavigationBlocked] = useState(false);

  const value = useMemo<NavigationConfirmationContextType>(() => {
    return {
      navigationBlocked,
      setNavigationBlocked,
    };
  }, [navigationBlocked]);

  return (
    <NavigationConfirmationContext.Provider value={value}>
      {children}
    </NavigationConfirmationContext.Provider>
  );
};

export const useNavigationConfirmationContext = () => {
  const context = useContext(NavigationConfirmationContext);
  if (!context) {
    throw new Error(
      'useNavigationConfirmationContext requires a NavigationConfirmationProvider',
    );
  }

  return context;
};
